import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user.js";
import tables from "./modules/tables.js";
import game from "./modules/game.js";
import call from "./modules/call.js";
import results from "./modules/results.js";
import chat from "./modules/chat.js";
import contacts from "./modules/contacts.js";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    tables,
    game,
    call,
    results,
    chat,
    contacts
  },
  state: {
    showHeader: true,
    acceptedCookie: false,
    audio: true,
  },
  getters: {
    showHeader: (state) => {
      return state.showHeader;
    },
    acceptedCookie: (state) => { 
      return state.acceptedCookie;
    },
    audioSetting: (state) => { 
      return state.audio;
    }
  },
  mutations: {
    setShowHeader(state, value) {
      state.showHeader = value;
    },
    acceptCookie(state) { 
      state.acceptedCookie = true;
    },
    changeAudioSetting(state) { 
      state.audio = !state.audio;
    }
  },
  plugins: [createPersistedState()],
});
